<template>
  <div class="bg-blue-5 rounded-lg p-6">
    <p class="font-bold mb-2">
      Expert analysis in your inbox
    </p>

    <p
      class="text-xs mb-4"
    >
      Our team help make it easy to understand how the news headlines affect your bank balance. Sign up for our weekly newsletter.
    </p>

    <form
      class="flex flex-col gap-4 mb-4"
      @submit.prevent="handleSubmit"
    >
      <AtomsInput
        v-model="email"
        placeholder="Email"
        label="Enter your email"
        theme="light"
        :is-success="emailValidation.isSuccess"
        :error-message="emailValidation.errorMessage"
        @input="validateForm"
      />

      <atoms-button
        type="submit"
        size="medium"
        full
        enable-tracking
      >
        SUBSCRIBE
      </atoms-button>
    </form>

    <p class="text-gray-80 text-2xs">
      By clicking ‘SUBSCRIBE', you acknowledge that your email address will be used and held in accordance with Compare Club's <a href="/terms-of-use/"><strong><u>Terms of Use</u></strong></a> and the <a href="/privacy-policy/"><strong><u>Privacy Policy</u></strong></a>, and would like to receive a weekly digest of Expert Analysis content.  You can unsubscribe from these communications at any time by clicking the unsubscribe link in the email.
    </p>
  </div>
</template>

<script setup>
import ExpertAnalysisService from '@/server/service/expert-analysis'

import { emailValidator } from '~/helpers/validator'

defineOptions({
  name: 'MoleculesExpertAnalysisSubscribeForm'
})

const { $toast } = useNuxtApp()
const { $tracking } = useNuxtApp()
const { mhEnvironment } = useEnv()
const service = new ExpertAnalysisService(mhEnvironment)

const email = ref('')
const emailValidation = reactive({
  isSuccess: false,
  errorMessage: ''
})

function validateForm () {
  const validate = email.value
    ? emailValidator(email.value)
    : false

  emailValidation.isSuccess = validate
  emailValidation.errorMessage = validate
    ? ''
    : 'Enter a valid email'
}

async function handleSubmit () {
  await validateForm()

  if (emailValidation.errorMessage) {
    return
  }

  const response = await service.subscribe({
    email: email.value
  })

  if (response.code === 200) {
    const emailHashed = hash256(email.value.toLowerCase())

    $tracking.customEvent('subscribedtopublication', {
      email_hashed: emailHashed
    })

    $toast.success(response.message)
  } else {
    $toast.erorr(response.message)
  }
}
</script>
